export default __webpack_public_path__ + "static/launch-partner_meebits_left@2x-37885abab91d34caab9c19c12f32e488.jpg";